export default __webpack_public_path__ + "static/media/mastercard.bc4530c1.svg";